import { z } from "zod";

import { AmplitudeEventIds } from "../constants";

import { amplitudeEvent } from "./base";

export const CustomerLTVPageGroupByEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.CUSTOMER_LTV_PAGE_SELECT_GROUPBY,
    camelCaseName: "customerLtvPageSelectGroupby",
    label: "Customer LTV Page Select groupby",
  },
  {
    groupBy: z.string(),
  },
);

export const CustomerLTVPageSelectDateRange = amplitudeEvent(
  {
    id: AmplitudeEventIds.CUSTOMER_LTV_PAGE_SELECT_DATE_RANGE,
    camelCaseName: "customerLtvPageSelectDateRange",
    label: "Customer LTV Page Select DateRange",
  },
  {
    dateRange: z.object({
      startDate: z.string(),
      endDate: z.string(),
    }),
  },
);

export const CustomerLTVPageSelectUpdateReport = amplitudeEvent(
  {
    id: AmplitudeEventIds.CUSTOMER_LTV_PAGE_SELECT_UPDATE_REPORT,
    camelCaseName: "customerLtvPageSelectUpdateReport",
    label: "Customer LTV Page Select Update Report",
  },
  {
    groupBy: z.string(),
    dateRange: z.object({
      startDate: z.string(),
      endDate: z.string(),
    }),
  },
);
export const CUSTOMER_LTV_PAGE_EVENTS = [
  CustomerLTVPageGroupByEvent,
  CustomerLTVPageSelectDateRange,
  CustomerLTVPageSelectUpdateReport,
] as const;
